import React from 'react';

const UiModeContext = /*#__PURE__*/React.createContext({
  uiMode: 'light',
  setUiMode: () => {
    console.warn('setUiMode called before it was assigned');
  }
});
var UiModeContext$1 = UiModeContext;

export { UiModeContext$1 as default };
//# sourceMappingURL=UiModeContext.js.map
